
import { useState } from "react";
import { useSelector } from "react-redux";

import Box from "@mui/material/Box";
import { Paper, Stack } from "@mui/material";

export default function StreakDataMonitoring() {

  const [show, setShow] = useState(false)
  const streaks = useSelector( store => store.streak.streaks) //fetchStreakData

  function handleClick(){
    setShow(!show)
  }

  return (
    <Paper
      sx={{
        padding: 2,
        mt: 1
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center" }}>

        <Stack>
        <div>
          <button onClick={handleClick}>
            Show/Hide Streak Fetch Status
          </button>
        </div>

        { show == true &&
          <div>
            <h1>
              Streak Data Monitoring
            </h1>
            { streaks?.length >0  ? <p>  fetchStreakData ✅</p> : <p>  fetchStreakData  ❌</p> }

          </div>
        }
        </Stack>

      </Box>
    </Paper>
  );
}
